import paymentTrackerFactory from 'shared_js/modules/tracker/paymentTrackerFactory';

import tracker from 'lib/windowTracker';

export default paymentTrackerFactory(tracker, {
  eventSchema: 'lakupandai_event',
});
